import { styled } from 'styled-components';
import { observer } from 'mobx-react-lite';
import { getUserChosenDirectoryHandle } from '../../State/FileSystem';
import { ExtensionSettings } from '../../State/EvidenceDB/DbExtensionSettings';


export const SidePanelContainerElement = styled.div`
	min-height: 100vh;
	width: 100%;
	padding: 1rem;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: start;
	align-items: stretch;
	background-color: rgba(248, 248, 248, 1);
`;



export const SettingsPageView = observer( () => {
	const extensionSettings = ExtensionSettings.current;
	if (extensionSettings == null) return null;
	const updatedPreferredArchiveDirectoryHandle = async () => {
		const directoryHandle = await getUserChosenDirectoryHandle({mode: 'readwrite'});
		if (directoryHandle != null) {
			extensionSettings.updateSettings({archiveDirectoryHandle: directoryHandle});
		}
	}
	const removePreferredArchiveDirectoryHandle = async () => {
		extensionSettings.updateSettings({archiveDirectoryHandle: undefined});
	}
	return (
		<SidePanelContainerElement>
			<h1>Data Goes Where? — Settings</h1>
			<h3>Instrumentation known to break some sites</h3>
			<label>
				<input type="checkbox" 
							 checked={ extensionSettings.settings.proxyDomEventsToDetectPropertiesRead }
							 onChange={ (e) => extensionSettings.updateSettings({proxyDomEventsToDetectPropertiesRead: e.currentTarget.checked})} />
				Instrument document (DOM) events to report on which event properties are read. (e.g., are keys read on keydown events?)
			</label>
			<label>
				<input type="checkbox" 
							 checked={ extensionSettings.settings.proxyDomMessageEventsToDetectDataRead }
							 onChange={ (e) => extensionSettings.updateSettings({proxyDomMessageEventsToDetectDataRead: e.currentTarget.checked})} />
				Instrument cross-window message events to detect whether messages were read.		 
			</label>
			<label>
				<input type="checkbox" 
							 checked={ extensionSettings.settings.monitorInboundNetworkTraffic }
							 onChange={ (e) => extensionSettings.updateSettings({monitorInboundNetworkTraffic: e.currentTarget.checked})} />
				Monitor inbound network traffic. (outbound is always monitored)		 
			</label>
			<label>
				<input type="text" disabled={true} value={extensionSettings.settings.archiveDirectoryHandle?.name ?? ""}
				/>
				<button onClick={updatedPreferredArchiveDirectoryHandle}>change</button>
				<button onClick={removePreferredArchiveDirectoryHandle}>remove</button>
				Preferred directory for saving recordings
			</label>
			{/* <button onClick={() => {ExtensionSettings.clear() }} >Reset settings to defaults</button> */}
		</SidePanelContainerElement>
	);
});
